import React from 'react';

const FaqBanner = () =>{
    return (
        <>
        <div className='cadFaqBanner cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/faq-banner.webp"
            alt="fa-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>FAQ</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default FaqBanner;